'use strict';

import _ from 'lodash';

import getDisplayPlans from './getDisplayPlans.jsx';
import planTypeToPlanId from 'ck-core/source/functions/planTypeToPlanId';

export default function(...args) {
	return _.map(getDisplayPlans(...args), planTypeToPlanId);
}
